import React, { useState, useEffect } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { dashboardApiConfig } from "src/config";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  Grid,
  Box,
  Button,
  makeStyles,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  FormHelperText,
  TextField,
  Typography,
  hexToRgb,
  CardActionArea,
} from "@material-ui/core";
import wait from "src/utils/wait";
import { withStyles, styled } from "@material-ui/core/styles";
import { ExpandMore } from "@material-ui/icons";

import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";

import track from "src/utils/analytics";
import { Link as RouterLink } from "react-router-dom";


const StyledTextField = styled(TextField, {
  name: "StyledTextField",
})({
  width: "200%",
  "@media (max-width: 600px)": {
    width: "100%",
  },
});

const Accordion = withStyles({
  root: {
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "#474343",
    color: "#ffffff",

    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: { color: "#ffffff" },
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

const useStyles = makeStyles(() => ({
  root: {},
  paper: {
    padding: "2px 2px",
    display: "flex",
    alignItems: "center",
    width: 400,
    height: 65,
  },
  divider: {
    height: 30,
    margin: 5,
  },
  cardHeader: {
    color: hexToRgb("#787878"),
  },
}));

const ImageQRCode = ({ className, text, format, qrcodeName, ...rest }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState("expand_image");

  const url_accordioan = (urlaccordioan) => (event, newExpanded) => {
    setExpanded(newExpanded ? urlaccordioan : false);
  };

  const [light, setLight] = useState("#ffffff");
  const [dark, setDark] = useState("#050505");



  const handleDownloadQRCodeEvent = () => {
    track.event("download_qrcode_apitier");
  };
 
  const redirectAIQRCodeEvent = () => {
    track.event("redirect_aiqrcodes_from_apitier");
  };

  const downloadqrCode = async () => {
    try {
      handleDownloadQRCodeEvent();

      const link = document.createElement("a");
      link.href = 'https://www.apitier.com/static/london_eye_with_people_around.png';
      link.download = "artistic_qrcode.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error(err);
    }
  };


  return (
    <Grid
      className={clsx(classes.root, className)}
      container
      spacing={3}
      {...rest}
    >
      <Grid item lg={8} md={6} xl={9} xs={12}>
        <Formik
          enableReinitialize
          initialValues={{
            name: text,
            colorlight: light,
            colordark: dark,
            submit: null,
          }}
          validationSchema={Yup.object().shape({
            name: Yup.string()
              .max(255)
              .required("Please enter url to generate qrcode"),
            colorlight: Yup.string().max(255),
            colordark: Yup.string().max(255),
            customlogo: Yup.string().max(255),
          })}
          onSubmit={async (
            values,
            { resetForm, setErrors, setStatus, setSubmitting }
          ) => {
            try {

              await wait(200);
              resetForm();
              setStatus({ success: true });
              setSubmitting(false);
            } catch (err) {
              console.error(err);
              setStatus({ success: false });
              setErrors({ submit: err.message });
              setSubmitting(false);
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            isSubmitting,
            touched,
            values,
          }) => (
            <form>
              <Card className={clsx(classes.root, className)} {...rest}>
                <Box
                  display="flex"
                  alignItems="center"
                  flexDirection="column"
                  textAlign="center"
                >
                  <Typography variant="h2" align="left" color="textPrimary">
                    <br />
                    Convert Any Image into QR Code!!
                  </Typography>
                </Box>
                <CardHeader></CardHeader>
                <Divider />

                <Accordion
                  expanded={expanded === "expand_url"}
                  onChange={url_accordioan("expand_url")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="expand_url_content"
                    id="expand_url_header"
                  >
                    <Typography>ENTER URL</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <CardContent>
                      <Grid container>
                        <Grid item md={20} xs={12}>
                          <StyledTextField
                            error={Boolean(touched.name && errors.name)}
                            fullWidth
                            helperText={touched.name && errors.name}
                            label="Enter url"
                            name="name"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.name}
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                      {errors.submit && (
                        <Box mt={3}>
                          <FormHelperText error>{errors.submit}</FormHelperText>
                        </Box>
                      )}
                    </CardContent>
                  </AccordionDetails>
                </Accordion>
                <Divider />
                <br />

                <Accordion
                  expanded={expanded === "expand_image"}
                  onChange={url_accordioan("expand_image")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="expand_image_content"
                    id="expand_url_header"
                  >
                    <Typography>IMAGE DESCRIPTION</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <CardContent>
                      <Grid container>
                        <Grid item md={20} xs={12}>
                          <StyledTextField
                            error={Boolean(touched.name && errors.name)}
                            fullWidth
                            helperText={touched.name && errors.name}
                            label="Enter Image Description"
                            name="name"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value='London Eye with people around'
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                      {errors.submit && (
                        <Box mt={3}>
                          <FormHelperText error>{errors.submit}</FormHelperText>
                        </Box>
                      )}
                    </CardContent>
                  </AccordionDetails>
                </Accordion>

                <br />

                <Divider />

                <Box p={2} display="flex" justifyContent="flex-end">

                  
                  <Button
                    color="secondary"
                    disabled={isSubmitting}
                    type="submit"
                    target="_blank"
                    variant="contained"
                    component={RouterLink}
                    onClick={redirectAIQRCodeEvent}
                    to={{ pathname: "https://ai.qrcodes.apitier.com/register" }}
                  >
                    Get Started Now!!
                  </Button>
                </Box>
              </Card>
            </form>
          )}
        </Formik>
      </Grid>
      <Grid item lg={4} md={6} xl={3} xs={12}>
        <Card className={clsx(classes.root, className)} {...rest}>
        <CardActionArea
                    component={RouterLink}
                    to={{ pathname: "https://ai.qrcodes.apitier.com/login" }}
                    onClick={redirectAIQRCodeEvent}
                    target="_blank"
                  >
          <CardContent>
            <Box
              display="flex"
              alignItems="center"
              flexDirection="column"
              textAlign="center"
            >
                <img
                alt="Artistic QR Code"
                style={{ width: '100%', height: '100%', }}
                src="/static/london_eye_with_people_around.png"
              />
            
            </Box>
          </CardContent>
          </CardActionArea>

          <CardActions>
            <Button
              fullWidth
              alignItems="center"
              variant="contained"
              color="secondary"
              onClick={downloadqrCode}
            >
              Download QRCode
            </Button>
          </CardActions>
          <Divider />
          <Box p={2} display="flex" justifyContent="flex-end">
            <Button
              fullWidth
              alignItems="center"
              variant="contained"
              color="secondary"
              component={RouterLink}
              to={{ pathname: "https://ai.qrcodes.apitier.com/login" }}
              target="_blank"
              onClick={redirectAIQRCodeEvent}
            >
              GET AI Generated QR Code
            </Button>
          </Box>
        </Card>
      </Grid>
    </Grid>
  );
};

ImageQRCode.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  format: PropTypes.string,
  qrcodeName: PropTypes.string,
};

export default ImageQRCode;
